import { createStore } from 'vuex';

/**
 * Глобальный стор, должен быть пустым. Использовать модули.
 */
const store = createStore({});
export default store;
